import { render, staticRenderFns } from "./ViewSubject.vue?vue&type=template&id=0f9bbb1b&scoped=true&"
import script from "./ViewSubject.vue?vue&type=script&lang=js&"
export * from "./ViewSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9bbb1b",
  null
  
)

export default component.exports